namespace SkillGroupParentPOSTConstants {
  export const ID_MAX_LENGTH = 256;
  export const MAX_JSON_OVERHEAD = 1000;
  export const MAX_POST_PAYLOAD_LENGTH = ID_MAX_LENGTH + MAX_JSON_OVERHEAD;
}

export default SkillGroupParentPOSTConstants;
